export default {
    methods: {
        clickMe() {
            alert("Clicked")
        }
    },
    watch: {
    }
}